<template>
  <main class="appointment-section" :class="{ 'is-modal': isModal }">
    <h1 class="section-title" v-if="!isModal && !isMobile">
      Thông tin đặt lịch hẹn
    </h1>
    <div class="appointment-content">
      <div class="scheduler-column" v-if="!isModal && !isMobile">
        <div class="calendar-container">
          <VCalendar
            v-model="selectedDate"
            is-expanded
            :attributes="calendarAttributes"
            @dayclick="renderSlots"
            :show-adjacent-months="true"
            @did-move="handleMonthChange"
          />
        </div>
        <div class="time-slots-container">
          <div class="time-group">
            <h3 class="time-group-title">Buổi sáng</h3>
            <div class="time-buttons-grid">
              <template v-if="morningSlots.length > 0">
                <button
                  v-for="slot in morningSlots"
                  :key="slot.startTime"
                  class="time-button"
                  :class="{ selected: selectedTimeSlot === slot }"
                  @click="selectedTimeSlot = slot"
                >
                  {{ slot.startTime }}
                </button>
              </template>
            </div>
            <template v-if="morningSlots.length === 0">
              <span class="disabled">Không có lịch</span>
            </template>
          </div>
          <div class="time-group">
            <h3 class="time-group-title">Buổi chiều</h3>
            <div class="time-buttons-grid">
              <template v-if="afternoonSlots.length > 0">
                <button
                  v-for="slot in afternoonSlots"
                  :key="slot.startTime"
                  class="time-button"
                  :class="{ selected: selectedTimeSlot === slot }"
                  @click="selectedTimeSlot = slot"
                >
                  {{ slot.startTime }}
                </button>
              </template>
            </div>
            <template v-if="afternoonSlots.length === 0">
              <span class="disabled">Không có lịch</span>
            </template>
          </div>
          <div class="time-group">
            <h3 class="time-group-title">Buổi tối</h3>
            <div class="time-buttons-grid">
              <template v-if="eveningSlots.length > 0">
                <button
                  v-for="slot in eveningSlots"
                  :key="slot.startTime"
                  class="time-button"
                  :class="{ selected: selectedTimeSlot === slot }"
                  @click="selectedTimeSlot = slot"
                >
                  {{ slot.startTime }}
                </button>
              </template>
            </div>
            <template v-if="eveningSlots.length === 0">
              <span class="disabled">Không có lịch</span>
            </template>
          </div>
        </div>
      </div>
      <div class="form-column">
        <div class="clinic-info-card" v-if="!isModal && !isMobile">
          <h2 class="clinic-name">{{ clinicInfo?.name }}</h2>
          <div class="clinic-details">
            <p class="clinic-address">
              <img src="../assets/images/icon-address.svg" alt="Address icon" />
              <span>{{`${clinicInfo?.address}, ${clinicInfo?.street}, ${clinicInfo?.ward?.title}, ${clinicInfo?.district?.title}, ${clinicInfo?.city?.title}`}}</span>
            </p>
            <p class="clinic-hotline">
              <img src="../assets/images/icon-call.svg" alt="Phone icon" />
              <span
                >Hotline: <strong>{{ clinicInfo?.phone }}</strong></span
              >
            </p>
          </div>
        </div>
        <Form
          class="appointment-form"
          :class="{ 'appointment-form-mobile': isMobile }"
          @submit="handleSubmit"
        >
          <div class="form-row">
            <div class="form-group">
              <label for="phone"
                >Số điện thoại<span class="required">*</span></label
              >
              <Field
                name="phone"
                rules="required|phone"
                v-slot="{ field, errors }"
                :value="formItem.userPhone"
              >
                <input
                  type="text"
                  v-bind="field"
                  :class="[{ 'is-invalid': !!errors.length }, 'form-control']"
                  v-model="formItem.userPhone"
                />
              </Field>
            </div>
            <div class="form-group">
              <label for="name">Họ & Tên<span class="required">*</span></label>
              <Field
                name="name"
                rules="required"
                v-slot="{ field, errors }"
                :value="formItem.userName"
              >
                <input
                  type="text"
                  v-bind="field"
                  :class="[{ 'is-invalid': !!errors.length }, 'form-control']"
                  v-model="formItem.userName"
                />
              </Field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="city"
                >Tỉnh/Thành phố<span v-if="isAddressRequired" class="required"
                  >*</span
                ></label
              >
              <Field
                name="city"
                v-slot="{ field, errors }"
                :rules="isAddressRequired ? 'required' : ''"
              >
                <VueMultiselect
                  v-bind="field"
                  v-model="formItem.city"
                  :options="provinceData"
                  :multiple="false"
                  :close-on-select="true"
                  label="title"
                  track-by="id"
                  @select="renderWard"
                  placeholder="--Chọn--"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #noOptions> Không có dữ liệu </template>
                  <template #noResult> Không có dữ liệu </template>
                </VueMultiselect>
              </Field>
            </div>
            <div class="form-group">
              <label for="ward"
                >Phường/Xã<span v-if="isAddressRequired" class="required"
                  >*</span
                ></label
              >
              <Field
                name="ward"
                v-slot="{ field, errors }"
                :rules="isAddressRequired ? 'required' : ''"
              >
                <VueMultiselect
                  v-bind="field"
                  v-model="formItem.ward"
                  :options="wardData"
                  :multiple="false"
                  :close-on-select="true"
                  label="title"
                  track-by="id"
                  placeholder="--Chọn--"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #noOptions> Không có dữ liệu </template>
                  <template #noResult> Không có dữ liệu </template>
                </VueMultiselect>
              </Field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="address"
                >Địa chỉ
                <span v-if="isAddressRequired" class="required">*</span></label
              >
              <Field
                name="address"
                v-slot="{ field, errors }"
                :rules="isAddressRequired ? 'required' : ''"
              >
                <input
                  type="text"
                  v-bind="field"
                  placeholder="Số nhà, tên đường,... "
                  :class="[{ 'is-invalid': !!errors.length }, 'form-control']"
                  v-model="formItem.address"
                />
              </Field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="pet-name">Tên thú cưng</label>
              <input type="text" id="pet-name" v-model="formItem.petName" />
            </div>
            <div class="form-group">
              <label for="pet-species">Loài thú cưng</label>
              <Field name="pet-species" v-slot="{ field, errors }">
                <VueMultiselect
                  v-bind="field"
                  v-model="formItem.petSpecies"
                  :options="petSpeciesData"
                  :multiple="false"
                  :close-on-select="true"
                  label="name"
                  track-by="id"
                  @select="renderPetBreed"
                  placeholder="--Chọn--"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #noOptions> Không có dữ liệu </template>
                  <template #noResult> Không có dữ liệu </template>
                </VueMultiselect>
              </Field>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="pet-breed">Giống thú cưng</label>
              <Field name="pet-breed" v-slot="{ field, errors }">
                <VueMultiselect
                  v-bind="field"
                  v-model="formItem.petBreed"
                  :options="petBreedData"
                  :multiple="false"
                  :close-on-select="true"
                  label="label"
                  track-by="id"
                  placeholder="--Chọn--"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #noOptions> Không có dữ liệu </template>
                  <template #noResult> Không có dữ liệu </template>
                </VueMultiselect>
              </Field>
            </div>
            <div class="form-group">
              <label for="request"
                >Yêu cầu<span class="required">*</span></label
              >
              <Field name="request" v-slot="{ field, errors }" rules="required">
                <VueMultiselect
                  v-bind="field"
                  v-model="formItem.request"
                  :options="requestData"
                  :multiple="true"
                  :close-on-select="false"
                  label="name"
                  track-by="id"
                  placeholder="--Chọn--"
                  :class="{ 'is-invalid': errors.length > 0 }"
                >
                  <template #noOptions> Không có dữ liệu </template>
                  <template #noResult> Không có dữ liệu </template>
                </VueMultiselect>
              </Field>
            </div>
          </div>
          <div class="form-group" v-if="!isModal">
            <label for="notes">Ghi chú</label>
            <textarea
              id="notes"
              v-model="formItem.note"
              placeholder="Nhập..."
              :rows="isMobile ? 1 : 2"
            ></textarea>
          </div>
          <div v-else class="form-row flex-row">
            <div class="form-group">
              <label for="notes">Ghi chú</label>
              <input
                type="text"
                id="notes"
                v-model="formItem.note"
                placeholder="Nhập..."
              />
            </div>
            <div class="form-group">
              <label for="notes">Thời gian hẹn</label>
              <div class="form-row flex-row" style="gap: 10px">
                <div class="form-group">
                  <v-date-picker
                    v-model="selectedDate"
                    :popover="{ visibility: 'focus' }"
                    :show-adjacent-months="true"
                    color="blue"
                    @dayclick="renderSlots"
                    :attributes="calendarAttributes"
                    @did-move="handleMonthChange"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input :value="inputValue" v-on="inputEvents" readonly />
                    </template>
                  </v-date-picker>
                </div>
                <div class="form-group">
                  <Field name="time" v-slot="{ field, errors }">
                    <VueMultiselect
                      v-bind="field"
                      v-model="selectedTimeSlot"
                      :options="selectedDaySlots"
                      :multiple="false"
                      :close-on-select="true"
                      label="startTime"
                      track-by="startTime"
                      placeholder="--Chọn--"
                      :class="{ 'is-invalid': errors.length > 0 }"
                    >
                      <template #noOptions> Không có dữ liệu </template>
                      <template #noResult> Không có dữ liệu </template>
                    </VueMultiselect>
                  </Field>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isMobile">
            <label for="notes">Thời gian hẹn</label>
            <div class="form-row" style="gap: 10px; flex-direction: row">
              <div class="form-group">
                <v-date-picker
                  v-model="selectedDate"
                  :popover="{ visibility: 'focus' }"
                  :show-adjacent-months="true"
                  color="blue"
                  @dayclick="renderSlots"
                  :attributes="calendarAttributes"
                  @did-move="handleMonthChange"
                >
                  <template #default="{ inputValue, inputEvents }">
                    <input :value="inputValue" v-on="inputEvents" readonly />
                  </template>
                </v-date-picker>
              </div>
              <div class="form-group">
                <Field name="time" v-slot="{ field, errors }">
                  <VueMultiselect
                    v-bind="field"
                    v-model="selectedTimeSlot"
                    :options="selectedDaySlots"
                    :multiple="false"
                    :close-on-select="true"
                    label="startTime"
                    track-by="startTime"
                    placeholder="--Chọn--"
                    :class="{ 'is-invalid': errors.length > 0 }"
                  >
                    <template #noOptions> Không có dữ liệu </template>
                    <template #noResult> Không có dữ liệu </template>
                  </VueMultiselect>
                </Field>
              </div>
            </div>
          </div>
          <div class="form-row checkbox-row justify-content-between">
            <div class="checkbox-group">
              <input type="checkbox" id="pickup" v-model="formItem.pickup" />
              <label for="pickup">Bạn có cần đón thú cưng không?</label>
            </div>
            <div
              v-if="!isModal"
              class="form-row submit-row"
              :class="{ 'submit-row-mobile': isModal }"
            >
              <button type="submit" class="submit-button">đặt lịch ngay</button>
            </div>
          </div>
          <hr class="hr-modal-line" v-if="isModal" />
          <div class="form-row" v-if="isModal">
            <div class="clinic-info-card clinic-info-card-modal">
              <h2 class="clinic-name">{{ clinicInfo?.name }}</h2>
              <div class="clinic-details">
                <p class="clinic-address">
                  <img
                    src="../assets/images/icon-address.svg"
                    alt="Address icon"
                  />
                  <span>{{ clinicInfo?.address }}</span>
                </p>
                <p class="clinic-hotline">
                  <img src="../assets/images/icon-call.svg" alt="Phone icon" />
                  <span
                    >Hotline: <strong>{{ clinicInfo?.phone }}</strong></span
                  >
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="isModal"
            class="form-row submit-row"
            :class="{ 'submit-row-mobile': isModal }"
          >
            <button
              type="button"
              v-if="isModal"
              class="cancel-button"
              @click="$emit('cancel')"
            >
              Hủy bỏ
            </button>
            <button type="submit" class="submit-button">đặt lịch ngay</button>
          </div>
          <div class="form-row" v-if="isMobile" style="margin-top: 20px">
            <div class="clinic-info-card clinic-info-card-modal">
              <h2 class="clinic-name">{{ clinicInfo?.name }}</h2>
              <div class="clinic-details">
                <p class="clinic-address">
                  <img
                    src="../assets/images/icon-address.svg"
                    alt="Address icon"
                  />
                  <span>{{ clinicInfo?.address }}</span>
                </p>
                <p class="clinic-hotline">
                  <img src="../assets/images/icon-call.svg" alt="Phone icon" />
                  <span
                    >Hotline: <strong>{{ clinicInfo?.phone }}</strong></span
                  >
                </p>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </main>

  <footer class="footer-mobile" v-if="isMobile">
    <img
      src="../assets/images/footer-bg-mobile.svg"
      alt="bg"
      class="footer-bg"
      style="width: 100%"
    />
  </footer>

  <ModalComp
    v-model="isOpen"
    @close="isOpen = false"
    :size="isMobile ? 'auto' : 'sm'"
    height="auto"
    :showCustomClose="true"
    isBack
  >
    <p class="title-qr">
      Tải QR về máy và đưa cho nhân viên quét khi tới phòng khám
    </p>
    <div class="qr-container-img">
      <img :src="qrDataUrl" alt="QR Code" />
    </div>
    <button class="download-qr" @click="downloadQR">
      <img
        src="../assets/images/icon-download.svg"
        alt="download"
        class="icon-download"
      />
      Tải về máy
    </button>
  </ModalComp>
</template>

<script>
import { Field, Form } from "vee-validate";
import VueMultiselect from "vue-multiselect";
import ClinicScheduleService from "../services/clinic-schedule.service";
import { format, parse, isBefore } from "date-fns";
import CategoryService from "../services/category.service";
import { TABLE_NAME } from "../constants/tableName";
import AppointmentService from "../services/appointment.service";
import Swal from "sweetalert2";
import QRCode from "qrcode";
import ModalComp from "../components/ModalComp.vue";
import { STATUS, ANIMAL_TYPE } from "../constants/constants";

export default {
  components: {
    Field,
    Form,
    VueMultiselect,
    ModalComp,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formItem: {
        request: [],
      },
      selectedDate: format(new Date(), "yyyy-MM-dd"),
      slotsData: [],
      selectedDaySlots: [],
      morningSlots: [],
      afternoonSlots: [],
      eveningSlots: [],
      selectedTimeSlot: null,
      provinceData: [],
      wardData: [],
      petSpeciesData: ANIMAL_TYPE,
      petBreedData: [],
      petBreedAllData: [],
      requestData: [],
      isAddressRequired: false,
      isAddressRequiredInit: false,
      isOpen: false,
      clinicSchedule: null,
      clinicInfo: null,
    };
  },
  created() {
    this.initData();
  },
  watch: {
    "formItem.pickup": function (newVal) {
      if (this.isAddressRequiredInit === false) {
        this.isAddressRequired = newVal || false;
      }
    },
    "formItem.city": function (newVal) {
      if (newVal === null) {
        this.formItem.ward = null;
        this.wardData = [];
      }
    },
    "formItem.petSpecies": function (newVal) {
      if (newVal === null) {
        this.formItem.petBreed = null;
        this.petBreedData = [];
      }
    },
  },
  computed: {
    calendarAttributes() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const slotAttrs = this.slotsData
        .filter((d) => {
          const date = new Date(d.date);
          date.setHours(0, 0, 0, 0);
          return d.slots.length > 0 && date >= today;
        })
        .map((d) => ({
          key: d.date,
          dates: new Date(d.date),
          highlight: { color: "green", fillMode: "light" },
        }));

      // slotAttrs.push({
      //     key: "today",
      //     dates: new Date(),
      //     highlight: { color: "blue", fillMode: "outline" }
      // });

      if (this.selectedDate) {
        slotAttrs.push({
          key: "selected",
          dates: new Date(this.selectedDate),
          highlight: { color: "#076c71" },
          customData: { selected: true },
        });
      }

      return slotAttrs;
    },
    isMobile() {
      return window.innerWidth < 576;
    },
  },
  methods: {
    async initData() {
      await this.getClinicInfo();

      await Promise.all([
        this.getClinicSchedule(),
        this.getProvinceData(),
        this.getPetBreedData(),
        this.getAppointmentRequestData(),
      ])
      
      await this.renderSlots({ date: new Date() });
    },
    async getProvinceData() {
      const data = await CategoryService.getCities("", true);
      this.provinceData = JSON.parse(JSON.stringify(data || []));
    },
    async getPetBreedData() {
      this.petBreedAllData = await CategoryService.getDataByCollectionName(
        TABLE_NAME.PET_BREED
      );
    },
    async getAppointmentRequestData() {
      this.requestData = await CategoryService.getDataByCollectionName(
        TABLE_NAME.APPOINTMENT_REQUEST
      );
    },
    renderPetBreed() {
      this.formItem.petBreed = null;
      this.petBreedData = this.petBreedAllData?.filter(
        (d) => d.type === this.formItem.petSpecies?.id && d.is_publish === true
      ).sort((a, b) => a.label.localeCompare(b.label));
    },
    renderSlots(day) {
      this.selectedDate = format(day.date, "yyyy-MM-dd");
      const dayData = this.slotsData.find((d) => d.date === this.selectedDate);
      this.selectedDaySlots = dayData ? dayData.slots : [];

      this.morningSlots = [];
      this.afternoonSlots = [];
      this.eveningSlots = [];

      for (const slot of this.selectedDaySlots) {
        if (slot.availableSlots > 0) {
          const slotTime = parse(slot.startTime, "HH:mm", new Date());

          if (isBefore(slotTime, parse("13:00", "HH:mm", new Date()))) {
            this.morningSlots.push(slot);
          } else if (isBefore(slotTime, parse("17:00", "HH:mm", new Date()))) {
            this.afternoonSlots.push(slot);
          } else {
            this.eveningSlots.push(slot);
          }
        }
      }
    },
    async renderWard(city) {
      this.formItem.ward = null;
      const data = await CategoryService.getDistricts(city.id);
      this.wardData = JSON.parse(JSON.stringify(data || []));
    },
    handleMonthChange(pages) {
      const page = pages[0];
      this.getClinicSchedule(page.month, page.year);
      this.morningSlots = [];
      this.afternoonSlots = [];
      this.eveningSlots = [];
    },
    async getClinicInfo() {
      this.clinicSchedule = (
        await CategoryService.getDataByField(
          TABLE_NAME.CLINIC_SCHEDULES,
          "url",
          this.$route.params.id
        )
      )[0];
      this.isAddressRequiredInit = this.isAddressRequired =
        this.clinicSchedule?.isAddressRequired || false;
      this.clinicInfo = (
        await CategoryService.getDataByField(
          TABLE_NAME.CLINIC,
          "_id",
          this.clinicSchedule?.clinicId
        )
      )[0];
    },
    async getClinicSchedule(month, year) {
      this.slotsData = (
        await ClinicScheduleService.getClinicSchedule(
          this.clinicInfo?._id,
          month,
          year
        )
      ).slots;
    },
    generateAppointmentId() {
      const now = new Date();
      const year = now.getFullYear();
      const YYYY = year.toString();
      
      const startOfYear = new Date(year, 0, 1);
      const diffTime = now - startOfYear;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
      const DDD = diffDays.toString().padStart(3, '0');
      
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let XXXXXX = '';
      for (let i = 0; i < 6; i++) {
        XXXXXX += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      
      return `OL${YYYY}${DDD}${XXXXXX}`;
    },
    async handleSubmit() {
      if (this.selectedDate === null || this.selectedTimeSlot === null) {
        Swal.fire({
          title: "Lỗi",
          text: "Vui lòng chọn ngày và giờ của lịch hẹn",
          icon: "error",
          confirmButtonColor: "#076c71",
          confirmButtonText: "OK",
          width: 400,
          timer: 3000,
        });
        return;
      }
      this.formItem.clinicId = this.clinicInfo?._id;
      this.formItem.provinceId = Number(this.formItem.city?.id) || null;
      this.formItem.communeId = Number(this.formItem.ward?.id) || null;
      this.formItem.petType = this.formItem.petSpecies?.id;
      this.formItem.petBreed = this.formItem.petBreed?.id;
      this.formItem.requireIds = this.formItem.request.map((r) => Number(r.id));
      this.formItem.date = this.selectedDate;
      this.formItem.startTime = this.selectedTimeSlot.startTime;
      this.formItem.endTime = this.selectedTimeSlot.endTime;
      this.formItem.status = STATUS.PENDING;
      this.formItem.isPickup = this.formItem.pickup;
      this.formItem.appointmentId = this.generateAppointmentId();

      delete this.formItem.request;
      delete this.formItem.city;
      delete this.formItem.ward;
      delete this.formItem.pickup;
      delete this.formItem.petSpecies;

      try {
        const res = await AppointmentService.createAppointment(this.formItem);
        if (!res) {
          throw new Error("Không lấy được mã lịch hẹn");
        }
        const qrDataUrl = await QRCode.toDataURL(String(this.formItem.appointmentId));
        if (this.isModal) {
          this.$emit("confirm", qrDataUrl);
        } else {
          this.qrDataUrl = qrDataUrl;
          this.isOpen = true;
        }
      } catch (error) {
        Swal.fire({
          title: "Lỗi",
          text: "Không tạo được mã QR. Vui lòng thử lại.",
          icon: "error",
          confirmButtonColor: "#076c71",
          confirmButtonText: "OK",
          width: 400,
        });
      }
    },
    downloadQR() {
      const link = document.createElement("a");
      link.href = this.qrDataUrl;
      link.download = "qr-code.png";
      link.click();
    },
  },
};
</script>

<style scoped>
.appointment-section {
  max-width: 1340px;
  margin: 0 auto;
}

.appointment-section.is-modal {
  padding: 0;
}

.appointment-section.is-modal .appointment-form {
  padding: 10px 15px;
  margin-bottom: 0 !important;
}

.appointment-form-mobile {
  padding: 0 !important;
  margin-bottom: 0 !important;
}

.section-title {
  font-size: 25px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0 0 33px 0;
}

.appointment-content {
  display: flex;
  gap: 10px;
}

.scheduler-column {
  flex: 0 0 372px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-column {
  flex: 1;
  position: relative;
}

.calendar-container {
  background-color: var(--white-color);
  border-radius: 10px;
  padding-bottom: 20px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 10px 10px 0 0;
}

.calendar-nav {
  display: flex;
  gap: 5px;
  cursor: pointer;
}

.calendar-month {
  font-size: 16px;
  font-weight: 600;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 20px;
  padding: 20px;
  text-align: center;
}

.weekday {
  font-size: 14px;
  font-weight: 600;
}

.day {
  font-size: 14px;
  line-height: 30px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
}

.day.disabled {
  color: var(--text-light);
  cursor: not-allowed;
}

.day.bordered {
  border: 1px solid var(--primary-color);
}

.day.selected {
  background-color: var(--primary-color);
  color: var(--white-color);
}

.time-slots-container {
  background-color: var(--white-color);
  border-radius: 10px;
  padding: 25px;
}

.time-group {
  margin-bottom: 18px;
}

.time-group:last-child {
  margin-bottom: 0;
}

.time-group-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-black);
  margin: 0 0 12px 0;
}

.time-buttons-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.time-button {
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background-color: var(--white-color);
  color: var(--text-dark);
  font-size: 16px;
}

.time-button:hover {
  background-color: var(--primary-color);
  color: var(--white-color);
  border-color: var(--primary-color);
  transition: all 0.2s ease;
}

.time-button.selected {
  background-color: var(--primary-color);
  color: var(--white-color);
  border-color: var(--primary-color);
}

.clinic-info-card {
  background-color: var(--white-color);
  padding: 25px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.clinic-info-card-modal {
  padding: 0;
  margin-top: -15px;
}

.hr-modal-line {
  margin: 0 0 5px;
  height: 1px;
}

.clinic-name {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

.clinic-details p {
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.clinic-details p:last-child {
  margin-bottom: 0;
}

.clinic-details strong {
  font-weight: 600;
}

.appointment-form {
  background-color: var(--white-color);
  padding: 25px 30px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 40px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
}

.form-group .required {
  color: var(--red-color);
}

.form-group input,
.form-group textarea,
.form-group select,
.multi-select-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  font-size: 14px;
  outline: none;
}

.form-group textarea {
  resize: vertical;
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  background-color: var(--white-color);
}

.select-arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.multi-select-container {
  position: relative;
}

.multi-select-input {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  border: 1px solid var(--primary-color);
  min-height: 54px;
}

.tag {
  background-color: #f3f3f3;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}

.tag img {
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  background-color: var(--white-color);
  border-radius: 3px;
  box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.12);
  z-index: 10;
  padding: 12px 5px;
  display: flex;
  flex-direction: column;
}

.dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  color: var(--text-gray);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item.selected {
  background-color: var(--active-bg);
  color: var(--text-dark);
  font-weight: 600;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 14px;
}

.checkbox-group input[type="checkbox"] {
  width: 20px;
  height: 20px;
  border: 1px solid #c9cfd2;
  border-radius: 2px;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"]:checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
}

.checkbox-group label {
  font-weight: 400;
}

.submit-row {
  justify-content: flex-end;
}

.submit-row-mobile {
  flex-direction: row !important;
  justify-content: flex-end !important;
}

.submit-row-mobile button {
  width: 165px;
}

.submit-button {
  background-color: var(--primary-color);
  color: var(--white-color);
  font-size: 14px;
  font-weight: 600;
  padding: 0 25px;
  height: 48px;
  border-radius: 5px;
  text-transform: uppercase;
  border: none;
}

.cancel-button {
  background-color: transparent;
  color: var(--text-color);
  font-size: 14px;
  font-weight: 600;
  padding: 0 25px;
  height: 48px;
  border-radius: 5px;
  text-transform: uppercase;
  border: 1px solid #adb7bc;
}

@media (max-width: 1200px) {
  .appointment-section {
    padding: 20px;
  }

  .appointment-content {
    flex-direction: column;
  }

  .scheduler-column {
    flex: 1;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 20px;
  }

  .appointment-form {
    gap: 20px;
  }

  .submit-row {
    justify-content: center;
  }

  .submit-button {
    width: 100%;
  }
}

input:focus,
select:focus,
textarea:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 4px rgba(var(--primary-color), 0.5);
}

.title-qr {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: var(--primary-color);
}

@media screen and (max-width: 576px) {
  .title-qr {
    font-size: 16px;
  }
}

.qr-container-img {
  border: 1px solid var(--primary-color);
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 20px;
  border-radius: 10px;
}

.qr-container-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.download-qr {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 5px;
  height: 48px;
  background: var(--primary-color);
  border-radius: 2px;
  color: var(--white-color);
  width: 100%;
  border: none;
}
</style>
